import { render } from "./ylylinkCheck.vue?vue&type=template&id=4c508f2b&scoped=true"
import script from "./ylylinkCheck.vue?vue&type=script&lang=js"
export * from "./ylylinkCheck.vue?vue&type=script&lang=js"

import "./ylylinkCheck.vue?vue&type=style&index=0&id=4c508f2b&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c508f2b"]])

export default __exports__